import { Farm } from "./Farm";
import { Image } from "./Image";

export class FarmWithImages {
    public listObjectsFiles: Image [];
    public object: Farm;
}
